export const MSAL_ERROR_MESSAGE_INTERACTION_REQUIRED = 'interaction_required';
export const MSAL_ERROR_MESSAGE_BLOCK_TOKEN_REQUESTS = 'block_token_requests';
export const MSAL_ERROR_MESSAGE_USER_LOGIN_ERROR = 'user_login_error';
export const DASHBOARD_MAX_PROGRAMS_TO_DISPLAY = 25;
